import { render, staticRenderFns } from "./CreateStudioAdmins.vue?vue&type=template&id=520a8a8e&scoped=true"
import script from "./CreateStudioAdmins.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudioAdmins.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudioAdmins.vue?vue&type=style&index=0&id=520a8a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a8a8e",
  null
  
)

export default component.exports